import React from 'react';
import {openQuickSearch} from "../../navigation/actions/open-quick-search";
import openAdvancedSearch from "../../navigation/actions/open-advanced-search";

type Props = {
    message?: string
}

export default function MenuSearch_Loading(props: Props) {



    return (
        <div className="flex-column-center-center h-300">

            <div className="ui5-txt-no-accent-small m-t-20">
                Searching...
            </div>

        </div>
    )
}
